import { useFormContext } from "react-hook-form";
import { FormControl, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Input } from "@shadcn/components/ui/input";
import { SharedoOdsEntityType } from "./api";

type Props = {
  name: string;
  disabled?: boolean;
  entityType: SharedoOdsEntityType;
};

const FieldLabel = ({ children, required }: { children: string; required?: boolean }) => (
  <label className="text-sm font-medium">
    {children}
    {required ? <span className="text-destructive"> *</span> : <span className="font-normal text-muted-foreground"> (optional)</span>}
  </label>
);

export const SharedoOdsSearchManualEntry = ({ name, disabled, entityType }: Props) => {
  const { control } = useFormContext();
  const isOrganisation = entityType === "organisation";

  return (
    <div className="space-y-4">
      {isOrganisation ? (
        <FormField
          control={control}
          name={`${name}.organisationName`}
          rules={{ required: "Organisation name is required" }}
          render={({ field }) => (
            <FormItem>
              <FieldLabel required>Organisation name</FieldLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ""} disabled={disabled} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <FormField
            control={control}
            name={`${name}.firstName`}
            rules={{ required: "First name is required" }}
            render={({ field }) => (
              <FormItem>
                <FieldLabel required>First name</FieldLabel>
                <FormControl>
                  <Input {...field} value={field.value ?? ""} disabled={disabled} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name={`${name}.surname`}
            rules={{ required: "Surname is required" }}
            render={({ field }) => (
              <FormItem>
                <FieldLabel required>Surname</FieldLabel>
                <FormControl>
                  <Input {...field} value={field.value ?? ""} disabled={disabled} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      )}
      <FormField
        control={control}
        name={`${name}.email`}
        render={({ field }) => (
          <FormItem>
            <FieldLabel>Email</FieldLabel>
            <FormControl>
              <Input {...field} type="email" value={field.value ?? ""} disabled={disabled} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`${name}.phone`}
        render={({ field }) => (
          <FormItem>
            <FieldLabel>Phone</FieldLabel>
            <FormControl>
              <Input {...field} value={field.value ?? ""} disabled={disabled} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
